import {
    Avatar, Breadcrumb,
    Button,
    Dropdown,
    Layout,
    Space,
    theme,
    Typography,
} from 'antd'
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react'
import {useNavigate} from 'react-router-dom'
import UserContext from '../../context/users'
import './styles.css'
import {globalSearch} from '../../services/dashboard'
import { toast } from 'sonner'

const {Content} = Layout

export default function AdminLayout({
                                        children,
                                        withBackground = true,
                                        noPadding = false,
                                    }) {
    const [user] = useContext(UserContext)
    const navigate = useNavigate()
    const [searchResult, setSearchResult] = useState([])
    const [searchLoading, setSearchLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const ref = useRef()

    const search = useCallback((text) => {
        setSearchLoading(true)
        globalSearch(text)
            .then(({data}) => {
                setSearchResult(data)
                setSearchLoading(false)
            })
            .catch((e) => {
                toast.error('Falha ao realizar pesquisa, tente novamente.')
            })
    }, [])

    useEffect(() => {
        const dc = document.querySelector('body')
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
        const handle = (e) => {
            if (((isMac && e.metaKey) || (!isMac && e.ctrlKey)) && e.key === 'k') {
                ref?.current?.focus()
                return e.preventDefault()
            }
        }
        dc.addEventListener('keydown', handle)
        return () => dc.removeEventListener('keydown', handle)
    }, [ref])

    const {
        token: {colorBgContainer, borderRadius, colorBgLayout, colorSider},
    } = theme.useToken()

    useEffect(() => {
        if (searchValue?.length < 1) return

        let timeout = setTimeout(() => search(searchValue), 200)
        return () => clearTimeout(timeout)
    }, [searchValue])

    return (
        <Layout className="site-layout" style={{backgroundColor: withBackground ? colorSider : 'transparent'}}>
            <Content style={{
                padding: withBackground ? '8px' : 0,
                margin: withBackground ? '8px 8px 8px 0' : 0,
                overflow: 'auto',
                maxHeight: withBackground ? 'calc(100vh - 16px)' : '100vh',
                background: withBackground ? colorBgLayout : 'transparent',
                borderRadius: withBackground ? borderRadius : 0,
            }}>
                <div
                    style={{
                        padding: noPadding ? '0' : '1rem',
                        borderRadius,
                    }}
                >
                    {children}
                </div>
            </Content>
        </Layout>
    )
}
